<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/empresas-parceiras"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <EmpresaParceiraFormulario @send="editar" :empresa="empresa" />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Empresa editada com sucesso"
      @close="goToEmpresas"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import {
  editarEmpresaParceira,
  exibirEmpresaParceira,
} from "@/services/empresas-parceiras.js";
import EmpresaParceiraFormulario from "@/components/empresas-parceiras/EmpresaParceiraFormulario.vue";
export default {
  name: "EmpresaParceiraCriar",
  components: { EmpresaParceiraFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Empresas Parceiras",
        disabled: false,
        to: "/empresas-parceiras",
      },
      {
        text: "Editar Empresa Parceira",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    success: false,
    loadingBtn: false,
    messageError: null,
    empresa: {},
    loading: false
  }),
    beforeCreate() {
    if(this.$store.state.user.data.tipo === "Representante") {
      this.$router.push({path: '/'})
    }
  },
  created() {
    this.exibir();
  },
  methods: {
    async editar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await editarEmpresaParceira(this.$route.params.id, event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    async exibir() {
      this.error = false;
      this.loading = true;
      try {
        const resp = await exibirEmpresaParceira(this.$route.params.id);
        this.empresa = resp.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.messageError =  e.response.data.message;
      }
    },
    goToEmpresas() {
      this.sucess = false;
      this.$router.push({ name: "EmpresasParceiras" });
    },
  },
};
</script>

<style></style>
